import { PortfolioCancellationFeeExtent } from '@mews-commander/data-access';

export enum CancellationFeeExtentFieldOption {
    TimeUnits = PortfolioCancellationFeeExtent.TimeUnits,
    Products = PortfolioCancellationFeeExtent.Products,
    TimeUnitsAndProducts = 'TimeUnitsAndProducts',
}
